import { render, staticRenderFns } from "./FootballHeatmap.vue?vue&type=template&id=33185ece&scoped=true&"
import script from "./FootballHeatmap.vue?vue&type=script&lang=js&"
export * from "./FootballHeatmap.vue?vue&type=script&lang=js&"
import style0 from "./FootballHeatmap.vue?vue&type=style&index=0&id=33185ece&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33185ece",
  null
  
)

export default component.exports